import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../main/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class SessionSyncService {
    private initialized = false;

    constructor(
        private router: Router,
        private authService: AuthService,
        private ngZone: NgZone
    ) {}

    init(): void {
        if (this.initialized) {
            return;
        }
        this.initialized = true;

        window.addEventListener('storage', (event: StorageEvent) => {
            if (event.key !== 'token') {
                return;
            }
            this.ngZone.run(() => {
                if (event.newValue === null) {
                    // Otra pestaña hizo logout: expulsar a esta también.
                    this.authService.isAuthenticated = false;
                    this.router.navigate(['/auth/login']);
                } else if (event.oldValue === null && event.newValue) {
                    // Otra pestaña hizo login y antes esta estaba sin sesión.
                    // Recargamos para que AuthGuard cargue el perfil y aplique roles.
                    window.location.reload();
                }
            });
        });
    }
}
